import { authFetch } from '../../../api/csrf';
import { get, post, put, patch, del } from '../../apiClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Internal Support Tickets APIs
export const internalTicketService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.scope) params.append('scope', options.scope);
            if (options.search) params.append('search', options.search);
            if (options.status && options.status !== 'all') params.append('status', options.status);
            if (options.priority && options.priority !== 'all') params.append('priority', options.priority);
            if (options.startDate) params.append('startDate', options.startDate);
            if (options.endDate) params.append('endDate', options.endDate);
            if (options.department && options.department !== 'all') params.append('department', options.department);
            if (options.page) params.append('page', options.page);
            if (options.limit) params.append('limit', options.limit);

            const response = await get(`${API_BASE_URL}/crm/support/internal-tickets?${params.toString()}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getById: async (id) => {
        try {
            const response = await get(`${API_BASE_URL}/crm/support/internal-tickets/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/crm/support/internal-tickets`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    addComment: async (id, data) => {
        try {
            const response = await post(`${API_BASE_URL}/crm/support/internal-tickets/${id}/comments`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    close: async (id, data = {}) => {
        try {
            const response = await patch(`${API_BASE_URL}/crm/support/internal-tickets/${id}/close`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    rate: async (id, data) => {
        try {
            const response = await post(`${API_BASE_URL}/crm/support/internal-tickets/${id}/rate`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getKPIs: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.department && options.department !== 'all') params.append('department', options.department);
            const qs = params.toString();
            const response = await get(`${API_BASE_URL}/crm/support/internal-tickets/kpis${qs ? '?' + qs : ''}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getSettings: async () => {
        try {
            const response = await get(`${API_BASE_URL}/crm/support/internal-tickets/settings`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    updateSettings: async (data) => {
        try {
            const response = await put(`${API_BASE_URL}/crm/support/internal-tickets/settings`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Upload a file attachment to Cloudinary via backend proxy
    uploadAttachment: async (file, folder = 'ticket-attachments') => {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('folder', folder);            const response = await authFetch(`${API_BASE_URL}/crm/support/internal-tickets/upload`, {
        credentials: 'include',
                method: 'POST',
                
                body: formData
            });
            const json = await response.json();
            if (!json.success) throw new Error(json.responseMessage || 'Upload failed');
            return json.data;
        } catch (error) {
            throw error;
        }
    }
};

// Internal Approvals APIs
export const internalApprovalService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.type) params.append('type', options.type);
            if (options.status) params.append('status', options.status);
            if (options.search) params.append('search', options.search);
            if (options.category && options.category !== 'all') params.append('category', options.category);
            if (options.startDate) params.append('startDate', options.startDate);
            if (options.endDate) params.append('endDate', options.endDate);
            if (options.page) params.append('page', options.page);
            if (options.limit) params.append('limit', options.limit);

            const response = await get(`${API_BASE_URL}/crm/support/internal-approvals?${params.toString()}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getById: async (id) => {
        try {
            const response = await get(`${API_BASE_URL}/crm/support/internal-approvals/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/crm/support/internal-approvals`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    submitDecision: async (id, data) => {
        try {
            const response = await post(`${API_BASE_URL}/crm/support/internal-approvals/${id}/decision`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getKPIs: async () => {
        try {
            const response = await get(`${API_BASE_URL}/crm/support/internal-approvals/kpis`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get approvers list (no employee_management permission required)
    getApprovers: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (typeof options === 'string') {
                if (options) params.append('search', options);
                params.append('limit', '50');
            } else {
                if (options.search) params.append('search', options.search);
                if (options.page) params.append('page', options.page);
                if (options.limit) params.append('limit', options.limit);
            }
            const response = await get(`${API_BASE_URL}/crm/support/internal-approvals/approvers?${params.toString()}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Upload a file attachment to Cloudinary via backend proxy
    uploadAttachment: async (file, folder = 'support-attachments') => {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('folder', folder);            const response = await authFetch(`${API_BASE_URL}/crm/support/internal-approvals/upload`, {
        credentials: 'include',
                method: 'POST',
                
                body: formData
            });
            const json = await response.json();
            if (!json.success) throw new Error(json.responseMessage || 'Upload failed');
            return json.data;
        } catch (error) {
            throw error;
        }
    }
};

